'use client';

import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
interface SectionShellProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  id?: string;
}
export function SectionShell({
  children,
  className,
  fullWidth = false,
  id
}: SectionShellProps) {
  return <section id={id} className={cn('relative w-full py-12', className)} data-sentry-component="SectionShell" data-sentry-source-file="section-shell.tsx">
      <div className={cn('relative z-10', fullWidth ? 'w-full' : 'container mx-auto px-4 sm:px-6 lg:px-8 max-w-[1200px] py-12')}>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-sentry-element="unknown" data-sentry-source-file="section-shell.tsx">
          {children}
        </motion.div>
      </div>
    </section>;
}